import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export default function SiteLayout() {
  useLenis();
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="bg-ink min-h-screen relative flex flex-col" data-testid="site-layout">
      <div className="tech-grid" />
      <div className="noise-overlay" />
      <Header />
      <main className={`flex-1 ${isHome ? "" : "pt-20"}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
